{
  "{0} Invitation(s) successfully sent": "{0} Invitation(s) successfully sent",
  "{0} properties added to the brand": "{0} properties added to the brand",
  "{0} properties added to the cluster": "{0} properties added to the cluster",
  "{0} properties added to user": "{0} properties added to user",
  "{assigned} of {total} User assigned | {assigned} of {total} Users assigned": "{assigned} van {total} toegewezen gebruikers | {assigned} van {total} toegewezen gebruikers",
  "{count} properties": "{count} properties",
  "{count} weren't updated": "{count} zijn niet bijgewerkt",
  "{num} user(s) assigned to the property": "{num} gebruiker(s) toegewezen aan de eigenschap",
  "{num} user(s) assigned to the site": "{num} gebruiker(s) toegewezen aan de site",
  "1 wasn't updated": "1 is niet bijgewerkt",
  "A cluster or brand with this name already exists. Please, choose another one.": "Er bestaat al een cluster of merk met deze naam. Kies een andere.",
  "A page with this name already exists. Please, choose another one.": "Er bestaat al een pagina met deze naam. Kies alstublieft een andere.",
  "A report will be sent by email every first week of the month summarizing the previous months data.": "A report will be sent by email every first week of the month summarizing the previous month's data.",
  "A report will be sent by email every week summarizing the previous weeks data.": "A report will be sent by email every week summarizing the previous week's data.",
  "A report will be sent by email summarizing the previous days data.": "A report will be sent by email summarizing the previous day's data.",
  "Access to data analytics on the Personalization Dashboard and BenchDirect for specific properties of the account": "Toegang tot gegevensanalyses op het Personalisatiedashboard en BenchDirect voor specifieke eigenschappen van de account",
  "Access to operate in all products for specific properties of the account, without permission to edit settings": "Toegang om te werken in alle producten voor specifieke eigenschappen van de account, zonder toestemming om instellingen te bewerken",
  "Account": "Account",
  "Account information": "Account information",
  "Account settings": "Account settings",
  "Account users": "Account users",
  "Account was successfully updated.": "Het account is succesvol bijgewerkt.",
  "Action required: Please {link} to continue.": "Actie vereist: Gelieve {link} om verder te gaan.",
  "Activated": "Geactiveerd",
  "Add": "Voeg  toe",
  "Add another set of rules": "Nog een set regels toevoegen",
  "Add JavaScript condition": "JavaScript-voorwaarde toevoegen",
  "Add new notification": "Add new notification",
  "Add page": "Pagina toevoegen",
  "Add properties": "Add properties",
  "Add properties to this brand": "Add properties to this brand",
  "Add properties to this cluster": "Add properties to this cluster",
  "Add the email(s) of the user(s) you want to invite:": "Add the email(s) of the user(s) you want to invite:",
  "Add user(s) email...": "Add user(s) email...",
  "added": "added",
  "Admin": "Admin",
  "Adults Only": "Alleen volwassenen",
  "Airport Hotel": "Luchthaven Hotel",
  "All": "All",
  "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.": "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.",
  "All properties": "All properties",
  "All properties from all my accounts.": "All properties from all my accounts.",
  "All properties from this account selected.": "All properties from this account selected.",
  "All properties from this account.": "All properties from this account.",
  "All properties from your accounts selected.": "All properties from your accounts selected.",
  "All rules apply": "Alle regels zijn van toepassing",
  "All the properties were updated successfully.": "Alle eigenschappen zijn met succes bijgewerkt.",
  "All the sites were updated successfully.": "Alle sites zijn succesvol bijgewerkt.",
  "All your properties have already been assigned to a brand group. Transfer properties from other brands if you want to populate a new brand group": "Al uw eigendommen zijn reeds toegewezen aan een merkgroep. Transfer eigenschappen van andere merken als u een nieuwe merkgroep wilt vullen",
  "All your team members have access to this property.": "All your team members have access to this property.",
  "All your team members have access to this site.": "Al uw teamleden hebben toegang tot deze site.",
  "An error occurred while sending the email. Please try again later.": "Er is een fout opgetreden bij het verzenden van de e-mail. Probeer het later nog eens.",
  "An error occurred. Please try again": "An error occurs. Please try again",
  "analyst": "analist",
  "Analyst": "analist",
  "Any rule applies": "Elke regel is van toepassing",
  "Aparthotel": "Aparthotel",
  "Are you sure you want to delete this brand?": "Are you sure you want to delete this brand?",
  "Are you sure you want to delete this cluster?": "Are you sure you want to delete this cluster?",
  "Are you sure you want to proceed?": "Weet je zeker dat je door wilt gaan?",
  "Are you sure you want to remove the access?": "Are you sure you want to remove the access?",
  "Are you sure you want to remove this property from this brand?": "Are you sure you want to remove this property from this brand?",
  "Are you sure you want to remove this property from this cluster?": "Are you sure you want to remove this property from this cluster?",
  "Are you sure you want to remove this user from this account?": "Are you sure you want to remove this user from this account?",
  "Ask Ernest": "Vraag Ernest",
  "Available languages": "Available languages",
  "Back": "Terug",
  "Back to Pages": "Terug naar pagina's",
  "Beach": "Strand",
  "BenchDirect": "BenchDirect",
  "Benchdirect": "Benchdirect",
  "Benchmark the key metrics of your direct booking channel": "Benchmark de belangrijkste statistieken van uw directe boekingskanaal",
  "Benchmark the key metrics of your direct channel": "Benchmark de belangrijkste meetgegevens van uw directe kanaal",
  "Book multiplier": "Book multiplier",
  "Book Multiplier": "Book multiplier",
  "Booking Engine Pages": "Pagina's van de boekingsmotor",
  "Booking Engine pages include {pageExamples} and others. Your Booking Engine pages can't be edited. If you encounter any issues on these pages, please contact our Support team via chat.": "Booking Engine pagina's bevatten {pageExamples} en andere. Uw Booking Engine pagina's kunnen niet worden bewerkt. Als u problemen ondervindt op deze pagina's, neem dan contact op met ons Support team via chat.",
  "Boutique": "Boetiek",
  "Brand": "Merk",
  "Brand information": "Brand information",
  "Brand name": "Merknaam",
  "Brands": "Merken",
  "Brands allow you to group your properties however you may need.": "Met merken kunt u uw eigendommen groeperen zoals u dat wilt.",
  "Brands without any properties will be deleted after 30 days of inactivity": "Brands without any properties will be deleted after 30 days of inactivity",
  "Business": "Business",
  "Can’t access 1Password?": "Heb je geen toegang tot 1Password?",
  "Cancel": "Annuleren",
  "Casino": "Casino",
  "Category (Stars)": "Category (Stars)",
  "Change password": "Wijzig wachtwoord",
  "Change the user role to adjust permissions": "You can change the role of the user to modify his/her permissions",
  "Change your password": "Wijzig uw wachtwoord",
  "Check the items that you want to copy.": "Vink de items aan die u wilt kopiëren.",
  "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.": "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.",
  "Choose a beautiful picture of your site. This landing photo is used in multiple tools, whenever THN creates a page/email for the site. For example, in the Saved Searches email.": "Kies een mooie foto van uw site. Deze landingsfoto wordt in meerdere tools gebruikt wanneer THN een pagina/e-mail voor de site maakt. Bijvoorbeeld in de e-mail Opgeslagen zoekopdrachten.",
  "Choose a product to start": "Kies een product om te beginnen",
  "Choose file": "Choose file",
  "Choose for which properties you'll upload URLs": "Kies voor welke eigenschappen je URL's wilt uploaden",
  "Choose languages": "Talen kiezen",
  "City": "Stad",
  "Cluster Information": "Cluster Information",
  "Cluster name": "Clusternaam",
  "Clusters": "Clusters",
  "Clusters allow you to group your hotels with the same cluster.": "Clusters allow you to group your hotels with the same cluster.",
  "Clusters allow you to group your properties however you may need.": "Clusters allow you to group your properties however you may need.",
  "Color": "Color",
  "Conference": "Conferentie",
  "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.": "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.",
  "Confirm": "Bevestigen",
  "Confirm new password": "Bevestig nieuw wachtwoord",
  "Confirm password": "Wachtwoord bevestigen",
  "Content": "Inhoud",
  "Conversion": "conversie",
  "Convince your visitors to book directly on your website": "Overtuig uw bezoekers om direct op uw website te boeken",
  "Copied": "Copied",
  "Copied settings will be assigned to the selected properties:": "Gekopieerde instellingen worden toegewezen aan de geselecteerde eigenschappen:",
  "Copied settings will be assigned to the selected sites:": "Gekopieerde instellingen worden toegewezen aan de geselecteerde sites:",
  "Copy": "Copy",
  "Copy and paste this code just before the closing body tag {bodyTag} in all the funnel pages and any extra page where you want to use THN. If you have any doubt don't hesitate on contacting us.": "Kopieer en plak deze code net voor de afsluitende body tag {bodyTag} in alle funnel pagina's en elke extra pagina waar je THN wilt gebruiken. Als je twijfelt aarzel dan niet om contact met ons op te nemen.",
  "Copy settings to other corporate sites": "Instellingen kopiëren naar andere bedrijfssites",
  "Copy settings to other properties": "Copy settings to other properties",
  "Copy settings to other properties:": "Kopieer instellingen naar andere eigenschappen:",
  "Copy settings to other sites:": "Instellingen kopiëren naar andere sites:",
  "Corporate landing picture": "Bedrijfsfoto",
  "Corporate logo": "Bedrijfslogo",
  "Corporate picture": "Bedrijfsbeeld",
  "Corporate Sites": "Zakelijke sites",
  "corporate sites": "Zakelijke sites",
  "Create a Login item for your THN account. Click the three dots to the top right and choose “Scan QR code”. Find a {link}.": "Maak een inlogitem aan voor je THN-account. Klik op de drie puntjes rechtsboven en kies ‘QR-code scannen’. Zoek een {link}.",
  "Create brand": "Create brand",
  "Create cluster": "Create cluster",
  "Create Login item and scan QR code": "Maak een inlogitem aan en scan de QR-code",
  "Create new brand": "Create new brand",
  "Create new cluster": "Create new cluster",
  "Create new corporate site": "Nieuwe bedrijfssite maken",
  "Create notification": "Create notification",
  "Create site": "Maak site",
  "Create your account": "Maak uw account aan",
  "Create your first Corporate Site": "Maak uw eerste bedrijfssite",
  "Currency and date format preferences when there’s not a property selected. This applies to Overview and brand page reports.": "Voorkeuren voor valuta- en datumnotatie wanneer er geen eigenschap is geselecteerd. Dit geldt voor Overzichts- en merkpagina-rapporten.",
  "Currency format": "Currency format",
  "Currency in which you will see all the data for this corporate site.": "Valuta waarin u alle gegevens voor deze corporate site ziet.",
  "Currency in which you will see all the data for this property.": "Currency in which you will see all the data for this property.",
  "Current password": "Huidige wachtwoord",
  "Daily": "Daily",
  "Daily:": "Daily: ",
  "Dashboard": "Dashboard",
  "Data about a particular {propertyType} or a particular user is never shared. The data is used to create competitive sets (groups of hotels that you can measure your performance against) and compare metrics between your hotels and their compsets. All data shown in BenchDirect is aggregate data.": "Gegevens over een bepaald {propertyType} of een bepaalde gebruiker worden nooit gedeeld. De gegevens worden gebruikt om competitieve sets (groepen hotels waarmee u uw prestaties kunt meten) te maken en statistieken tussen uw hotels en hun compsets te vergelijken. Alle gegevens die in BenchDirect worden weergegeven, zijn geaggregeerde gegevens.",
  "Data updating": "Data updating",
  "Dates format": "Dates format",
  "Deactivated": "Gedeactiveerd",
  "Default currency": "Default currency",
  "Delete": "Schrappen",
  "Delete brand": "Delete brand",
  "Delete cluster": "Delete cluster",
  "Delete notification": "Kennisgeving verwijderen",
  "Delete page": "Pagina verwijderen",
  "Delete photo": "Delete photo",
  "Deleting the page will remove any active messages from it. Those messages will be active on any other pages they're assigned to.": "Als je de pagina verwijdert, worden alle actieve berichten verwijderd. Deze berichten blijven actief op alle andere pagina's waaraan ze zijn toegewezen.",
  "Demand": "Vraag",
  "demand_product_description": "Stuur gekwalificeerd verkeer naar je website via betaalde campagnes",
  "Didn't receive the email? {btn}": "Heb je de e-mail niet ontvangen? {btn}",
  "Disparities": "Disparities",
  "Do you already have an account? {btn}": "Heeft u al een account? {btn}",
  "Do you want to compare your performance to the market and competition? Access our hotel benchmarking analytics platform.": "Wilt u uw prestaties vergelijken met de markt en de concurrentie? Ga naar ons analyseplatform voor hotelbenchmarking.",
  "Do you want to delete this notification?": "Wil je deze melding verwijderen?",
  "Do you want to delete this page?": "Wil je deze pagina verwijderen?",
  "Do you want to get more direct bookings? Use personalization tools to tailor messages and offers according to each individual's behaviour.": "Wilt u meer directe boekingen krijgen? Gebruik personaliseringstools om berichten en aanbiedingen af te stemmen op het gedrag van elk individu.",
  "Don't remind me again": "Herinner me er niet meer aan.",
  "Don’t have an account? {btn}": "Heb je geen account? {btn}",
  "Download property list.": "Download eigendomslijst.",
  "Download template": "Sjabloon downloaden",
  "Drive qualified traffic to your hotel's website and effortlessly boost conversions thanks to our cutting-edge demand platform and fully-managed marketing services. Request a demo.": "Stuur gekwalificeerd verkeer naar de website van je hotel en verhoog moeiteloos conversies dankzij ons geavanceerde vraagplatform en volledig beheerde marketingservices. Vraag een demo aan.",
  "Drop files here": "Drop files here",
  "Drop icon": "Drop icon",
  "Each property can only use one mapping rule type per page, and they're already set to a different rule. Remove their existing rule first and import again.": "Elke eigenschap kan slechts één mappingregeltype per pagina gebruiken, en ze zijn al ingesteld op een andere regel. Verwijder eerst hun bestaande regel en importeer opnieuw.",
  "Edit": "Bewerken",
  "Edit account role": "Edit account role",
  "Edit brand": "Edit brand",
  "Edit cluster": "Edit cluster",
  "Edit notification": "Melding bewerken",
  "Edit Property": "Edit property",
  "Edit role": "Edit role",
  "Edit site": "Site bewerken",
  "Edit user": "Edit user",
  "Editing properties": "Eigenschappen bewerken",
  "Editing sites": "Sites bewerken",
  "Editing successful!": "Bewerken gelukt!",
  "Editing unsuccessful!": "Bewerken mislukt!",
  "Email": "E-mail",
  "Email communications from THN": "Email communications from THN",
  "Email notifications": "Email notifications",
  "Empty": "Empty",
  "English": "Engels",
  "english": "Engels",
  "English selected by default": "English selected by default",
  "Enter a 6-digit code": "Voer een 6-cijferige code in",
  "Enter a description for the site": "Voer een beschrijving van de site in",
  "Enter a password": "Voer een wachtwoord in",
  "Enter a password with at least 8 characters": "Voer een wachtwoord in van minimaal 8 tekens",
  "Enter the code from 1Password to verify your identity.": "Voer de code uit 1Password in om je identiteit te verifiëren.",
  "Enter the email address related to this account and we'll send you the instructions to reset your password.": "Vul het e-mailadres in dat bij dit account hoort zodat wij u de instructies om uw wachtwoord opnieuw in te stellen kunnen sturen.",
  "Enter your account name": "Enter your account name",
  "Enter your code": "Voer je code in",
  "Enter your current password": "Voer uw huidige wachtwoord in",
  "Enter your email": "Voer uw e-mail in",
  "Enter your last name": "Vul uw achternaam in",
  "Enter your name": "Vul uw naam in",
  "Enter your password": "Voer uw wachtwoord in",
  "Experience the power of next-gen AI across our products": "Ervaar de kracht van next-gen AI in al onze producten",
  "Family": "Familie",
  "First name": "Voornaam",
  "follow these instructions": "volg deze instructies",
  "Forgot your password?": "Wachtwoord vergeten?",
  "Forgot your password? {btn}": "Wachtwoord vergeten? {btn}",
  "Frequency": "Frequency",
  "Full access to all products as well as edit and manage all properties, invite users and assign roles": "Volledige toegang tot alle producten en alle eigenschappen bewerken en beheren, gebruikers uitnodigen en rollen toewijzen",
  "General preferences": "General preferences",
  "Get a digest in your inbox and keep track of your disparities.": "Get a digest in your inbox and keep track of your disparities.",
  "Get more info": "Meer informatie",
  "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.": "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.",
  "Get your summary report directly in your inbox!": "Get your summary report directly in your inbox!",
  "Go back": "Ga terug",
  "Go to Help Center": "Go to Help Center",
  "Golf": "Golf",
  "Google Analytics": "Google Analytics",
  "Group your properties by brand!": "Groepeer je vastgoedobjecten per merk!",
  "Having trouble with your data?": "Having trouble with your data?",
  "help center": "hulpcentrum",
  "Here you have a summary of some of the most common errors. Check it out!": "Here you have a summary of some of the most common errors. Check it out!",
  "Hostel": "Herberg",
  "Hotel address": "Hotel address",
  "Hotel information": "Hotel information",
  "Hotel landing picture": "Hotel landing picture",
  "Hotel logo": "Hotel logo",
  "Hotel profile": "Hotel profile",
  "Hotel Profile": "Hotel profile",
  "Hotel type": "Hotel type",
  "How is the data used and processed?": "How is the data used and processed?",
  "I agree to the terms and conditions of the {privacyPolicyLink}": "Ik ga akkoord met de algemene voorwaarden van de {privacyPolicyLink}",
  "I have already scanned it": "Ik heb het al gescand",
  "If enabled, every time widgets are shown an event will be created in Google Analytics.": "If enabled, every time widgets are shown an event will be created in Google Analytics.",
  "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.": "Als het e-mailadres overeenkomt met dat van uw account, ontvangt u binnenkort een e-mail met instructies voor het herstel van uw wachtwoord. Zorg ervoor dat u uw inbox ververst.",
  "If you are using Google Tag Manager (GTM), please {link} once you activate this setting.": "Als u Google Tag Manager (GTM) gebruikt, klikt u op {link} zodra u deze instelling activeert.",
  "If you remove this property, the brand will be empty and automatically deleted.": "Als u deze eigenschap verwijdert, wordt het merk leeg en automatisch verwijderd.",
  "If you remove this property, the cluster will be empty and automatically deleted.": "Als u deze eigenschap verwijdert, wordt het cluster leeggemaakt en automatisch verwijderd.",
  "Import": "Importeren",
  "Import URLs in bulk": "URL's in bulk importeren",
  "Incorrect email or password. Please try again or {link}.": "Onjuist e-mailadres of wachtwoord. Probeer het opnieuw of {link}.",
  "Info": "Info",
  "Install and login to the 1Password extension.": "Installeer de 1Password-extensie en log in.",
  "Install the 1Password browser extension": "Installeer de 1Password-browserextensie",
  "Install the THN Script on your website": "Installeer het THN-script op uw website",
  "Integration": "Integratie",
  "Integration setup": "Integration setup",
  "Invalid CSV format.": "Ongeldige CSV-indeling.",
  "Invalid or expired code, try again.": "Ongeldige of verlopen code, probeer het opnieuw.",
  "Invitation couldn't be sent": "De uitnodiging kon niet worden verzonden",
  "Invitation successfully sent.": "De uitnodiging is succesvol verzonden.",
  "Invite link expired": "Uitnodiging link verlopen",
  "Invite new user(s)": "Invite new user(s)",
  "Invite users": "Invite users",
  "It looks like this invite link has expired. Please check with your account owner or your Client Success Specialist if you need help.": "Het lijkt erop dat deze uitnodigingslink is verlopen. Neem contact op met je accounteigenaar of je Client Success Specialist als je hulp nodig hebt.",
  "It looks like this link has already been used or has expired.": "Het lijkt erop dat deze link al is gebruikt of is verlopen.",
  "JavaScript condition is": "JavaScript-voorwaarde is",
  "Language": "Language",
  "Language direction": "Taal richting",
  "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.": "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.",
  "Last name": "Achternaam",
  "Left to right": "Left to right",
  "Leisure": "Vrije tijd",
  "Loading ...": "Loading ...",
  "Log out": "Uitloggen",
  "Login": "Inloggen",
  "Logo": "Logo",
  "Looks like you are the only one in the account": "Looks like you are the only one in the account",
  "Luxury": "Luxe",
  "Manage languages": "Manage languages",
  "Manage Preferences": "Manage Preferences",
  "Manage the access to properties for this user.": "Manage the access to properties for this user.",
  "Mapped for": "In kaart gebracht voor",
  "Mapping Rules": "Regels voor het in kaart brengen",
  "Mapping Values": "Waarden in kaart brengen",
  "Meet Ernest": "Ontmoet Ernest",
  "Monthly": "Monthly",
  "Monthly:": "Monthly: ",
  "More information here": "Meer informatie hier",
  "Motel": "Motel",
  "Must accept terms and conditions": "Algemene voorwaarden moeten geaccepteerd worden",
  "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.": "Moet ten minste 1 kleine letter, 1 hoofdletter en 1 numeriek teken bevatten en moet tussen 8 en 20 karakters bevatten,",
  "Name": "Name",
  "New password": "Nieuw wachtwoord",
  "Next": "Next",
  "No account available with the name: {name}": "Geen account beschikbaar met de naam: {name}",
  "No brand created yet": "Er is nog geen merk aangemaakt",
  "No data found": "No data found",
  "No matches found for your search": "Er zijn geen resultaten gevonden voor uw zoekopdracht",
  "Nº of rooms": "Nº of rooms",
  "No properties": "Geen eigendommen",
  "No properties available.": "Geen eigenschappen beschikbaar.",
  "No properties found in this account": "Er zijn geen objecten gevonden in dit account",
  "No valid rows found.": "Geen geldige rijen gevonden.",
  "None": "None",
  "Not now": "Niet nu",
  "Notification created.": "Melding aangemaakt.",
  "Notification icon": "Notification icon",
  "Notification was deleted.": "De melding is verwijderd.",
  "Notification was saved.": "De melding is opgeslagen.",
  "Notifications": "Notifications",
  "Now selected:": "Nu geselecteerd:",
  "Now you can access to our products and boost your hotel direct bookings.": "Nu kunt u toegang krijgen tot onze producten en uw hotel directe boekingen stimuleren.",
  "of": "of",
  "Ok": "OK",
  "Once deleted, it can't be restored.": "Als het eenmaal is verwijderd, kan het niet meer worden hersteld.",
  "Only images are allowed": "Alleen afbeeldingen zijn toegestaan",
  "Oops! You don't have access to any account": "Oops! You don't have access to any account",
  "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.": "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.",
  "Operator": "operator",
  "Ops, something went wrong. Please try again later.": "Oeps, er is iets misgegaan. Probeer het later nog eens.",
  "optional": "Optioneel",
  "or": "or",
  "Overview preferences": "Overview preferences",
  "Owner": "eigenaar",
  "Ownership couldn't be transferred.": "Het eigendom kon niet worden overgedragen.",
  "Ownership successfully transferred.": "Eigendom succesvol overgedragen.",
  "Page deleted successfully": "Pagina succesvol verwijderd",
  "Page ID": "Pagina-ID",
  "Page name": "Naam van de pagina",
  "Page saved successfully": "Pagina succesvol opgeslagen",
  "Pages": "pagina's",
  "Pages created rely on the THN Script being installed to collect data and display your messages on the corresponding pages of your site.": "Pagina's die worden gemaakt vertrouwen erop dat het THN Script is geïnstalleerd om gegevens te verzamelen en uw berichten weer te geven op de bijbehorende pagina's van uw site.",
  "Password": "Wachtwoord",
  "Password reset sent": "Instructies om wachtwoord te herstellen verzonden",
  "Passwords do not match": "Wachtwoorden komen niet overeen",
  "Pending confirmation": "In afwachting van bevestiging",
  "Personal information": "Persoonlijke informatie",
  "Personalization": "Personalization",
  "Personalize the user experience to boost conversion rates": "Personaliseer de gebruikerservaring om de conversie te verhogen",
  "Personalize your hotel website's full funnel": "Personaliseer de volledige trechter van uw hotel website",
  "Please, complete the following information:": "Vul alstublieft de volgende gegevens in:",
  "Please, contact {btn}": "Neem contact op met {btn}",
  "Please, contact the person responsible for THN within your team.": "Please, contact the person responsible for THN within your team.",
  "Please, introduce your current password and then set a new one": "Voer eerst uw huidige wachtwoord in en stel dan een nieuw wachtwoord in",
  "Please, retry to edit these properties.": "Probeer deze eigenschappen opnieuw te bewerken.",
  "Please, retry to edit these sites.": "Probeer deze sites opnieuw te bewerken.",
  "Please, select the account in which you want to log in:": "Please, select the account in which you want to log in:",
  "Please, select the brand to allocate this property:": "Selecteer het merk om waar je dit hotel aan wil toewijzen:",
  "Please, select the cluster to allocate this property:": "Selecteer het cluster waar dit hotel toe behoort:",
  "Please, try again": "Probeer het opnieuw",
  "Preferences": "Voorkeuren",
  "Priority": "Prioriteit",
  "Privacy Policy": "Privacybeleid",
  "Profile": "Profiel",
  "Properties": "Hotels",
  "properties": "properties",
  "Properties included": "Inbegrepen hotels",
  "Properties selected": "Properties selected",
  "Property": "Property",
  "Property access": "Property access",
  "Property name": "Property name",
  "Property's script": "Bedrijfssite script",
  "QR code for two-factor authentication setup": "QR-code voor het instellen van tweefactorauthenticatie",
  "Ready to take your hotel's direct booking strategy to new heights?": "Klaar om de direct booking-strategie van je hotel naar nieuwe hoogten te brengen?",
  "Recipients": "Recipients",
  "RegExp contains": "RegExp Bevat",
  "Remind to this user to accept the invitation you sent to join the account.": "Herinner deze gebruiker eraan om de uitnodiging te accepteren die je hem/haar hebt gestuurd om lid te worden van het account.",
  "Remove access": "Remove access",
  "Remove from brand": "Remove from brand",
  "Remove from cluster": "Remove from cluster",
  "Remove properties and delete brand": "Eigenschappen verwijderen en merk verwijderen",
  "Remove properties and delete cluster": "Eigenschappen verwijderen en cluster verwijderen",
  "Remove property": "Remove property",
  "Remove user": "Remove user",
  "Removed access to {0} properties": "Removed access to {0} properties",
  "Removing {0} of {1}": "Removing {0} of {1}",
  "Repeat password": "Herhaal wachtwoord",
  "Reset password link expired": "Uitnodiging link verlopen",
  "Reset your password": "Reset uw wachtwoord",
  "Resort": "Vakantieoord",
  "Restricted property": "Beperkte eigendom",
  "Return to login": "Terug naar inloggen",
  "Right to left": "Right to left",
  "Role": "Role",
  "Rooms and Rates, Booking Confirmed, User Register Page": "Kamers en tarieven, boeking bevestigd, gebruikersregistratiepagina",
  "Save changes": "Wijzigingen opslaan",
  "Save new page": "Nieuwe pagina opslaan",
  "Save selection": "Selectie opslaan",
  "Search": "Zoek op",
  "Search ...": "Search ...",
  "Search account": "Search account",
  "Search brand...": "Zoek een merk...",
  "Search cluster...": "Zoek cluster...",
  "Search properties ...": "Search properties ...",
  "Search users...": "Gebruikers zoeken...",
  "Search...": "Search...",
  "Seems like there aren’t any brands created yet": "Het lijkt erop dat er nog geen merken zijn gemaakt",
  "Seems like there aren’t any clusters created yet": "Het lijkt erop dat er nog geen clusters zijn aangemaakt",
  "Select a product": "Selecteer een product",
  "Select only languages that are available in your hotel website": "Select only languages that are available in your hotel website",
  "Select properties": "Eigenschappen selecteren",
  "Select property": "Selecteer eigenschap",
  "Select role for the user(s):": "Select role for the user(s):",
  "Select sites": "Sites selecteren",
  "Select the properties that you want to add to this brand:": "Selecteer de eigenschappen die u aan dit merk wilt toevoegen:",
  "Select the properties you want the notifications from:": "Select the properties you want the notifications from:",
  "Select the properties you want to add to this brand:": "Select the properties that you want to add to this brand:",
  "Select the properties you want to add to this cluster:": "Selecteer de eigenschappen die je wilt toevoegen aan dit cluster:",
  "Select the properties you want to assign to this user(s):": "Select the properties you want to assign to this user(s):",
  "Select the type of notification:": "Select the type of notification:",
  "Select the user(s) you want to share this property with:": "Select the user(s) you want to share this property with:",
  "Select the user(s) you want to share this site with:": "Selecteer de gebruiker(s) met wie u deze site wilt delen:",
  "selected": "selected",
  "Send a new one": "Stuur een nieuwe",
  "Send a reminder": "Een herinnering sturen",
  "Send invite(s)": "Send invite(s)",
  "Send periodic reports to anyone you wish": "Send periodic reports to anyone you wish",
  "Send reminder": "Herinnering versturen",
  "Send reset instructions": "Stuur herstelinstructies",
  "Set a new one here": "Stel hier een nieuwe in",
  "Set new password": "Nieuw wachtwoord instellen",
  "Set up 1Password 2FA": "1Password 2FA instellen",
  "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.": "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.",
  "Set your new password": "Stel uw nieuwe wachtwoord in",
  "Settings": "Settings",
  "Share": "Share",
  "Share property": "Share property",
  "Share site": "Site delen",
  "Show all": "Toon alle",
  "Sign in": "Aanmelden",
  "Sign in here": "Hier inloggen",
  "Sign up to join": "Log in of maak een nieuw profiel aan om lid te worden van deze account",
  "Single Apartment": "Appartement",
  "Site information": "Locatie-informatie",
  "Site logo": "Sitelogo",
  "Sites selected": "Sites geselecteerd",
  "Ski Resort": "Skigebied",
  "Something went wrong. Please try again or contact support via chat if the issue persists.": "Probeer het opnieuw of neem contact op met de klantenservice via chat als het probleem zich blijft voordoen.",
  "Specific properties": "Specific properties",
  "Specific properties from this account.": "Specific properties from this account.",
  "Start grouping your properties however you like!": "Begin met het groeperen van uw eigendommen zoals u dat wilt!",
  "Start inviting users to your team.": "Start inviting users to your team.",
  "step by step guide here": "Stap voor stap handleiding hier",
  "Take a tour": "Maak een rondleiding",
  "Team": "Team",
  "The account does not exist": "Het account bestaat niet",
  "The AI teammate that delivers intelligence, recommends your next move, and helps you act.": "De AI-teamgenoot die inzicht levert, je volgende zet adviseert en je helpt te handelen.",
  "The chatbot cannot be initialised": "De chatbot kan niet worden geïnitialiseerd",
  "The field length must be between 1 and 60 characters long.": "De veldlengte moet tussen 1 en 60 tekens liggen.",
  "The properties included will immediately become available to regroup in new brands.": "The properties included will immediately become available to regroup in new brands.",
  "The user already belongs to this account": "The user already belongs to this account",
  "The user has been locked out due to too many failed authentication attempts. Please {link} to continue.": "De gebruiker is vergrendeld vanwege te veel mislukte verificatiepogingen. Klik op {link} om door te gaan.",
  "The user will no longer have access to the properties.": "The user will no longer have access to the properties.",
  "There was an error deleting the page": "Er is een fout opgetreden bij het verwijderen van de pagina",
  "There was an error loading the page": "Er is een fout opgetreden bij het laden van de pagina",
  "There was an error saving the page": "Er is een fout opgetreden bij het opslaan van de pagina",
  "These pages are managed automatically": "Deze pagina's worden automatisch beheerd",
  "This action cannot be undone.": "Deze actie kan niet ongedaan worden gemaakt.",
  "This field is required": "Dit veld is verplicht",
  "This field must be a valid email": "Dit veld moet een geldig emailadres bevatten",
  "This field must be a valid URL, e.g. https://hotel.com": "Dit veld moet een geldige URL zijn, bijvoorbeeld https://hotel.com",
  "This field must be at least {min} characters": "Dit veld moet uit minstens {min} tekens bestaan",
  "This image will be used for reports, notifications and other account communications.": "This image will be used for reports, notifications and other account communications.",
  "This is your THN tracking code for {propertyName}. This script allows us to track and follow the complete booking funnel throughout your website and analyze the right metrics of your direct booking performance, as well as display all the widgets and messages you configure.": "Dit is uw THN-trackingcode voor {propertyName}. Met dit script kunnen we het volledige boekingsproces op uw website volgen en de relevante statistieken van uw directe boekingsprestaties analyseren, en bovendien alle widgets en berichten weergeven die u hebt geconfigureerd.",
  "This user already has access to all properties, you cant add more.": "This user already has access to all properties, you cant add more.",
  "This user will no longer be able to access to this/these property(ies).": "Deze gebruiker heeft geen toegang meer tot deze woning(en).",
  "Timeshare": "Timeshare",
  "Timezone": "Timezone",
  "Title": "Title",
  "Transfer ownership": "Eigendomsoverdracht",
  "Transfer properties and delete brand": "Eigenschappen overdragen en merk verwijderen",
  "Transfer properties and delete cluster": "Eigenschappen overdragen en cluster verwijderen",
  "Transfer property": "Hotel verplaatsen",
  "Transfer this property to another brand": "Verplaats dit hotel naar een ander merk",
  "Transfer this property to another cluster": "Verplaats dit hotel naar een ander cluster",
  "Transfer to another brand": "Transfer to another brand",
  "Transfer to another cluster": "Transfer to another cluster",
  "Untitled page": "Pagina zonder titel",
  "URL": "URL",
  "URL contains": "URL bevat",
  "URL equals": "URL is gelijk aan",
  "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.": "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.",
  "User": "User",
  "User invited": "User invited",
  "User removed": "Gebruiker verwijderd",
  "User role was successfully changed.": "De gebruikersrol is succesvol gewijzigd.",
  "User was successfully removed.": "User was successfully removed.",
  "Users": "Gebruikers",
  "Users invited": "Users invited",
  "Validating emails ...": "Validating emails ...",
  "Verify": "Controleer",
  "View brand": "Bekijk merk",
  "View cluster": "Cluster weergeven",
  "View info": "Bekijk info",
  "View Property": "Eigendom bekijken",
  "View site": "Site bekijken",
  "Visualize and analyze your brand data classifying those properties within the same brand into one group.": "Visualize and analyze your brand data classifying those properties within the same brand into one group.",
  "We respect your privacy, therefore we will not share your personal information with third parties or partners.": "We respect your privacy, therefore we will not share your personal information with third parties or partners.",
  "Weekly": "Weekly",
  "Weekly:": "Weekly: ",
  "Welcome": "Welkom",
  "Welcome {0},": "Welkom {0},",
  "Welcome to THN": "Welkom bij THN",
  "Wellness & Spa": "Wellness & Spa",
  "Widget data": "Widget data",
  "Without it, messages won’t be shown and no data will be collected.": "Zonder dit worden berichten niet weergegeven en worden er geen gegevens verzameld.",
  "Write the number of rooms": "Write the number of rooms",
  "Yes, remove access": "Yes, remove access",
  "Yes, remove user": "Yes, remove user",
  "You are about to delete this brand": "U staat op het punt dit merk te verwijderen",
  "You are about to delete this cluster": "U staat op het punt dit cluster te verwijderen",
  "You are about to transfer the ownership to this user. Your role will change to Operator, and you will no longer be able to edit the account information.": "Je staat op het punt om het eigendom over te dragen aan deze gebruiker. Uw rol zal veranderen in Operator en u zult niet langer in staat zijn om de accountinformatie te bewerken.",
  "You can add it again later.": "You can add it again later.",
  "You can’t invite users that are already in the account": "Je kunt geen gebruikers uitnodigen die al bij het account horen",
  "You haven't created any email notification yet": "Je hebt nog geen e-mailnotificatie aangemaakt",
  "You will see brands here when an admin user creates them.": "Hier kunt u merken zien wanneer een admin-gebruiker ze aanmaakt.",
  "You will see clusters here when an admin creates them.": "U zult hier clusters zien wanneer een admin ze aanmaakt.",
  "Your brand was successfully removed.": "Your brand was successfully removed.",
  "Your Brand was successfully updated.": "Your Brand was successfully updated.",
  "Your cluster was successfully removed.": "Your cluster was successfully removed.",
  "Your Cluster was successfully updated.": "Your Cluster was successfully updated.",
  "Your new password has been successfully set": "Uw nieuwe wachtwoord is succesvol ingesteld",
  "Your password was successfully changed.": "Uw wachtwoord is succesvol gewijzigd.",
  "Your profile was successfully updated.": "Je profiel is succesvol bijgewerkt.",
  "Your Properties was successfully removed from brand.": "Uw Eigenschappen is met succes verwijderd uit het merk.",
  "Your Properties was successfully removed from cluster.": "Uw eigenschappen zijn met succes uit het cluster verwijderd.",
  "Your properties was successfully transferred.": "Uw eigendommen zijn succesvol overgedragen.",
  "Your property was successfully updated.": "Your property was successfully updated.",
  "Your site was created.": "Uw website is aangemaakt.",
  "Your site was successfully updated.": "Uw site is succesvol bijgewerkt.",
  "Your verification session expired. Please sign in again.": "Uw verificatiesessie is verlopen. Meld u opnieuw aan."
}